import { Box } from 'components/elements'
import { StyledCell } from 'features/incidents/components/SentinelOne/IncidentsTable'
import { EmptyRecord, StyledRow, StyledTable } from 'features/incidents/components/style'
import { useMediaQuery } from 'react-responsive'
import { PolicyStatusEnum, TERMINOLOGY } from 'utils/enum'

const POLICY_TIMELINE_COLUMNS = [
  { id: 'status', label: `${TERMINOLOGY.warranty.singular} Status`, minWidth: 150 },

  { id: 'Time', label: 'Status Update Timestamp', minWidth: 150 },
]

const PolicyTimeline = ({ row }: any) => {
  const isDesktopOrLaptop = useMediaQuery({ minWidth: 991 })
  const policyTimelineList = row?.history || []

  return (
    <StyledTable css={{ marginBottom: '1rem' }} className={`${!isDesktopOrLaptop && policyTimelineList?.length ? 'table--mobile' : 'responsive-mobile'} `}>
      {isDesktopOrLaptop && (
        <thead>
          <StyledRow>
            {POLICY_TIMELINE_COLUMNS.map(column => (
              <StyledCell key={column.id} as="th" className={`minWidth-${column.minWidth}`} css={{ lineHeight: 1.9 }}>
                {column.label}
              </StyledCell>
            ))}
          </StyledRow>
        </thead>
      )}
      <tbody>
        <>
          {policyTimelineList?.length ? (
            policyTimelineList?.map((row: any, idx: number) => (
              <>
                <StyledRow key={idx}>
                  <StyledCell>
                    {!isDesktopOrLaptop && (
                      <Box as="h4" css={{ mb: 0 }}>
                        {TERMINOLOGY.warranty.singular} Status
                      </Box>
                    )}
                    {(row?.notes === PolicyStatusEnum.REACTIVATED
                      ? 'Reactivated'
                      : row?.notes === PolicyStatusEnum.CHANGE_POLICY
                      ? `${TERMINOLOGY.warranty.singular} Change`
                      : row?.status) + (row?.notes === PolicyStatusEnum.REACTIVATED ? ' ' : row.toPlanName ? ` -> (${row.toPlanName})` : '') || '-'}
                  </StyledCell>

                  <StyledCell>
                    {!isDesktopOrLaptop && (
                      <Box as="h4" css={{ mb: 0 }}>
                        Status Update Timestamp
                      </Box>
                    )}

                    {/* {(() => {
                      const noteToTimestampMap: Record<PolicyStatusEnum, string | undefined> = {
                        [PolicyStatusEnum.CHANGE_POLICY]: row.userPolicyChangedAt,
                        [PolicyStatusEnum.CANCEL]: row.userCancelledAt,
                        [PolicyStatusEnum.REACTIVATED]: row.policyReactivationAt,
                        [PolicyStatusEnum.EXPIRED]: row.expiredAt,
                      }

                      const displayTimestamp = noteToTimestampMap[row.notes as PolicyStatusEnum]

                      return <>{displayTimestamp ? moment(displayTimestamp).format('MMM Do YY') : '-'} </>
                    })()} */}
                    {row?.statusChangeTimestamp ? new Date(row?.statusChangeTimestamp).toLocaleString() : '-'}
                  </StyledCell>
                </StyledRow>
              </>
            ))
          ) : (
            <EmptyRecord colSpan={7} css={{ textAlign: 'center' }}>
              No Data
            </EmptyRecord>
          )}
        </>
      </tbody>
    </StyledTable>
  )
}

export default PolicyTimeline
